<template lang="html">
  <section class="section">
    <div class="container">
    <div class="columns is-centered">

      <div class="column is-two-thirds has-text-justified">
        <h1 class="title has-text-secondary">Contact us</h1>

          <p class="content">
            For any question or suggestion for the <b>Costuto</b> team, you can contact us at <span class="has-text-primary">contact@costuto.com</span>
            or you can fill the form below, we will come back to you as soon as possible !
          </p>
          <p class="content">
            If you are a <b>cosplay related shop</b> and want to become a <b>Costuto</b> official partner, you can find
            all informations in the section
            <router-link :to="{ path: `/sponsors` }">
            <b>Sponsors</b>.
            </router-link>
          </p>

          <ValidationObserver ref="observer" v-slot="{ handleSubmit }">

            <ValidationProvider slim rules="required" name="Name" v-slot="{ errors, valid }">
              <b-field label="Name" :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors">
                <b-input v-model="contact.name" icon="account-circle"></b-input>
              </b-field>
            </ValidationProvider>

             <b-field label="Subject">
              <b-input v-model="contact.subject" icon="message-text-outline"></b-input>
            </b-field>

            <ValidationProvider slim rules="required|email" name="Email" v-slot="{ errors, valid }">
              <b-field label="Email" :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="[errors[0],'We will answer you at this address']" >
                <b-input v-model="contact.email" placeholder="Email"
                    type="email"
                    icon="email">
                </b-input>
              </b-field>
            </ValidationProvider>

            <ValidationProvider slim rules="required" name="Message" v-slot="{ errors, valid }">
              <b-field label="Message" :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors">
                  <b-input v-model="contact.message" maxlength="200" type="textarea"></b-input>
              </b-field>
            </ValidationProvider>

            <vue-recaptcha ref="recaptcha" sitekey="6LeeROAZAAAAAAslfpwt5vHim5E-sQA83zGOHMRP" @verify="captcha = true" :loadRecaptchaScript="true"></vue-recaptcha>

            <b-button :disabled="!captcha" @click="handleSubmit(sendMessage)" type="is-primary">
              <b-icon icon="send" size="is-small"></b-icon>
              <span>Send</span>
            </b-button>

          </ValidationObserver>

      </div>
    </div>

    <!-- Loaders  -->

    <b-loading :is-full-page="true" :active.sync="isLoading"></b-loading>
    </div>
  </section>
</template>

<script>
import { notificationMixin } from '@/mixins/notificationMixin'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import _ from 'lodash'
import VueRecaptcha from 'vue-recaptcha'

export default {
  mixins: [ notificationMixin ],
  data () {
    return {
      contact: {
        name: null,
        subject: null,
        email: null,
        message: null
      },
      isLoading: false,
      captcha: false
    }
  },
  components: {
    ValidationObserver,
    ValidationProvider,
    VueRecaptcha
  },
  methods: {
    sendMessage () {
      this.isLoading = true
      this.debouncedSending()
    }
  },
  created () {
    let self = this
    this.debouncedSending = _.debounce(() => {
      self.$store.dispatch('contacts/create', self.contact)
        .then(_ => {
          self.emailSent()
          self.isLoading = false
        })
        .catch(_ => {
          console.log('error')
          self.isLoading = false
        })
    }, 3000)
  }
}
</script>

<style lang="css" scoped>
</style>
